import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import PromoCards from 'components/Products/USB-Webcams/IN-W1/PromoCards';
import SpecTable from 'components/Products/USB-Webcams/IN-W1/SpecTable';
import NavButtons from 'components/Products/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  PromoCards,
  SpecTable,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};